module.exports={
  "53033000100": {
    "key": 53033000100,
    "Population": 7985,
    "White": "53%",
    "Black": "14%",
    "Native Am.": "0%",
    "Asian": "14%",
    "Pacific Isl.": "2%",
    "Other": "0%",
    "Multiracial": "8%",
    "Hispanic": "9%"
  },
  "53033000200": {
    "key": 53033000200,
    "Population": 8498,
    "White": "58%",
    "Black": "8%",
    "Native Am.": "3%",
    "Asian": "13%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "6%",
    "Hispanic": "11%"
  },
  "53033000300": {
    "key": 53033000300,
    "Population": 2991,
    "White": "68%",
    "Black": "3%",
    "Native Am.": "0%",
    "Asian": "14%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "8%",
    "Hispanic": "6%"
  },
  "53033000401": {
    "key": 53033000401,
    "Population": 6560,
    "White": "58%",
    "Black": "11%",
    "Native Am.": "1%",
    "Asian": "16%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "8%"
  },
  "53033000402": {
    "key": 53033000402,
    "Population": 5419,
    "White": "77%",
    "Black": "4%",
    "Native Am.": "0%",
    "Asian": "7%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "6%"
  },
  "53033000500": {
    "key": 53033000500,
    "Population": 3143,
    "White": "83%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "9%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "3%"
  },
  "53033000600": {
    "key": 53033000600,
    "Population": 8124,
    "White": "60%",
    "Black": "9%",
    "Native Am.": "1%",
    "Asian": "12%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "5%",
    "Hispanic": "11%"
  },
  "53033000700": {
    "key": 53033000700,
    "Population": 5217,
    "White": "53%",
    "Black": "13%",
    "Native Am.": "1%",
    "Asian": "17%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "3%",
    "Hispanic": "12%"
  },
  "53033000800": {
    "key": 53033000800,
    "Population": 2710,
    "White": "81%",
    "Black": "3%",
    "Native Am.": "0%",
    "Asian": "8%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "0%"
  },
  "53033000900": {
    "key": 53033000900,
    "Population": 2009,
    "White": "80%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "10%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "4%"
  },
  "53033001000": {
    "key": 53033001000,
    "Population": 2055,
    "White": "65%",
    "Black": "12%",
    "Native Am.": "0%",
    "Asian": "14%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "3%"
  },
  "53033001100": {
    "key": 53033001100,
    "Population": 2752,
    "White": "64%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "26%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "5%",
    "Hispanic": "5%"
  },
  "53033001200": {
    "key": 53033001200,
    "Population": 7124,
    "White": "61%",
    "Black": "10%",
    "Native Am.": "0%",
    "Asian": "15%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "7%"
  },
  "53033001300": {
    "key": 53033001300,
    "Population": 4702,
    "White": "53%",
    "Black": "4%",
    "Native Am.": "0%",
    "Asian": "22%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "16%"
  },
  "53033001400": {
    "key": 53033001400,
    "Population": 5674,
    "White": "77%",
    "Black": "1%",
    "Native Am.": "1%",
    "Asian": "7%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "10%",
    "Hispanic": "2%"
  },
  "53033001500": {
    "key": 53033001500,
    "Population": 2752,
    "White": "87%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "6%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "1%"
  },
  "53033001600": {
    "key": 53033001600,
    "Population": 4758,
    "White": "82%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "6%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "8%",
    "Hispanic": "3%"
  },
  "53033001701": {
    "key": 53033001701,
    "Population": 4024,
    "White": "69%",
    "Black": "7%",
    "Native Am.": "1%",
    "Asian": "10%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "5%"
  },
  "53033001702": {
    "key": 53033001702,
    "Population": 5018,
    "White": "72%",
    "Black": "2%",
    "Native Am.": "1%",
    "Asian": "9%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "8%"
  },
  "53033001800": {
    "key": 53033001800,
    "Population": 5246,
    "White": "72%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "12%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "7%"
  },
  "53033001900": {
    "key": 53033001900,
    "Population": 4971,
    "White": "74%",
    "Black": "3%",
    "Native Am.": "0%",
    "Asian": "16%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "4%"
  },
  "53033002000": {
    "key": 53033002000,
    "Population": 3754,
    "White": "77%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "11%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "4%"
  },
  "53033002100": {
    "key": 53033002100,
    "Population": 4350,
    "White": "76%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "14%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "4%"
  },
  "53033002200": {
    "key": 53033002200,
    "Population": 5867,
    "White": "76%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "13%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "4%"
  },
  "53033002400": {
    "key": 53033002400,
    "Population": 3224,
    "White": "83%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "9%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "4%"
  },
  "53033002500": {
    "key": 53033002500,
    "Population": 3357,
    "White": "79%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "9%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "8%",
    "Hispanic": "3%"
  },
  "53033002600": {
    "key": 53033002600,
    "Population": 5268,
    "White": "77%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "9%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "5%"
  },
  "53033002700": {
    "key": 53033002700,
    "Population": 6415,
    "White": "73%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "12%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "8%",
    "Hispanic": "5%"
  },
  "53033002800": {
    "key": 53033002800,
    "Population": 4925,
    "White": "82%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "6%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "5%"
  },
  "53033002900": {
    "key": 53033002900,
    "Population": 4863,
    "White": "85%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "5%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "4%"
  },
  "53033003000": {
    "key": 53033003000,
    "Population": 6314,
    "White": "82%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "6%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "6%"
  },
  "53033003100": {
    "key": 53033003100,
    "Population": 6452,
    "White": "83%",
    "Black": "0%",
    "Native Am.": "1%",
    "Asian": "4%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "8%"
  },
  "53033003200": {
    "key": 53033003200,
    "Population": 8813,
    "White": "84%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "4%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "6%"
  },
  "53033003300": {
    "key": 53033003300,
    "Population": 7560,
    "White": "76%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "7%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "8%",
    "Hispanic": "7%"
  },
  "53033003400": {
    "key": 53033003400,
    "Population": 3630,
    "White": "86%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "7%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "3%",
    "Hispanic": "3%"
  },
  "53033003500": {
    "key": 53033003500,
    "Population": 4218,
    "White": "82%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "7%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "3%"
  },
  "53033003600": {
    "key": 53033003600,
    "Population": 7122,
    "White": "75%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "14%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "3%"
  },
  "53033003800": {
    "key": 53033003800,
    "Population": 2362,
    "White": "78%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "13%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "1%"
  },
  "53033003900": {
    "key": 53033003900,
    "Population": 3070,
    "White": "77%",
    "Black": "1%",
    "Native Am.": "1%",
    "Asian": "10%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "4%"
  },
  "53033004000": {
    "key": 53033004000,
    "Population": 3237,
    "White": "70%",
    "Black": "11%",
    "Native Am.": "0%",
    "Asian": "9%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "3%"
  },
  "53033004100": {
    "key": 53033004100,
    "Population": 8106,
    "White": "81%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "12%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "2%"
  },
  "53033004200": {
    "key": 53033004200,
    "Population": 8588,
    "White": "82%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "10%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "4%"
  },
  "53033004301": {
    "key": 53033004301,
    "Population": 3827,
    "White": "70%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "15%",
    "Pacific Isl.": "0%",
    "Other": "3%",
    "Multiracial": "4%",
    "Hispanic": "6%"
  },
  "53033004302": {
    "key": 53033004302,
    "Population": 4116,
    "White": "53%",
    "Black": "3%",
    "Native Am.": "0%",
    "Asian": "34%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "3%"
  },
  "53033004400": {
    "key": 53033004400,
    "Population": 7634,
    "White": "72%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "12%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "10%"
  },
  "53033004500": {
    "key": 53033004500,
    "Population": 3348,
    "White": "75%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "14%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "3%",
    "Hispanic": "5%"
  },
  "53033004600": {
    "key": 53033004600,
    "Population": 3623,
    "White": "88%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "5%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "2%"
  },
  "53033004700": {
    "key": 53033004700,
    "Population": 9409,
    "White": "77%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "10%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "6%"
  },
  "53033004800": {
    "key": 53033004800,
    "Population": 5213,
    "White": "84%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "7%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "2%"
  },
  "53033004900": {
    "key": 53033004900,
    "Population": 7058,
    "White": "84%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "6%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "5%",
    "Hispanic": "4%"
  },
  "53033005000": {
    "key": 53033005000,
    "Population": 4011,
    "White": "80%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "7%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "5%"
  },
  "53033005100": {
    "key": 53033005100,
    "Population": 3716,
    "White": "83%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "6%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "4%",
    "Hispanic": "5%"
  },
  "53033005200": {
    "key": 53033005200,
    "Population": 6674,
    "White": "50%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "35%",
    "Pacific Isl.": "1%",
    "Other": "1%",
    "Multiracial": "7%",
    "Hispanic": "4%"
  },
  "53033005301": {
    "key": 53033005301,
    "Population": 8226,
    "White": "42%",
    "Black": "3%",
    "Native Am.": "2%",
    "Asian": "39%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "8%",
    "Hispanic": "4%"
  },
  "53033005302": {
    "key": 53033005302,
    "Population": 5320,
    "White": "43%",
    "Black": "3%",
    "Native Am.": "1%",
    "Asian": "37%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "10%",
    "Hispanic": "6%"
  },
  "53033005400": {
    "key": 53033005400,
    "Population": 6120,
    "White": "78%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "9%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "8%",
    "Hispanic": "2%"
  },
  "53033005600": {
    "key": 53033005600,
    "Population": 6954,
    "White": "83%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "5%",
    "Pacific Isl.": "1%",
    "Other": "1%",
    "Multiracial": "5%",
    "Hispanic": "5%"
  },
  "53033005700": {
    "key": 53033005700,
    "Population": 6864,
    "White": "79%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "10%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "6%"
  },
  "53033005801": {
    "key": 53033005801,
    "Population": 5351,
    "White": "78%",
    "Black": "4%",
    "Native Am.": "1%",
    "Asian": "6%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "9%"
  },
  "53033005802": {
    "key": 53033005802,
    "Population": 5853,
    "White": "67%",
    "Black": "5%",
    "Native Am.": "0%",
    "Asian": "14%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "9%",
    "Hispanic": "5%"
  },
  "53033005900": {
    "key": 53033005900,
    "Population": 8030,
    "White": "76%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "9%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "8%",
    "Hispanic": "4%"
  },
  "53033006000": {
    "key": 53033006000,
    "Population": 5915,
    "White": "78%",
    "Black": "2%",
    "Native Am.": "1%",
    "Asian": "9%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "3%"
  },
  "53033006100": {
    "key": 53033006100,
    "Population": 5312,
    "White": "78%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "11%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "3%"
  },
  "53033006200": {
    "key": 53033006200,
    "Population": 4578,
    "White": "81%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "8%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "5%"
  },
  "53033006300": {
    "key": 53033006300,
    "Population": 5945,
    "White": "89%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "3%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "1%"
  },
  "53033006400": {
    "key": 53033006400,
    "Population": 3616,
    "White": "83%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "6%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "5%"
  },
  "53033006500": {
    "key": 53033006500,
    "Population": 4995,
    "White": "81%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "6%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "6%",
    "Hispanic": "5%"
  },
  "53033006600": {
    "key": 53033006600,
    "Population": 4245,
    "White": "79%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "12%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "3%"
  },
  "53033006700": {
    "key": 53033006700,
    "Population": 9508,
    "White": "62%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "28%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "3%"
  },
  "53033006800": {
    "key": 53033006800,
    "Population": 3356,
    "White": "85%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "10%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "3%"
  },
  "53033006900": {
    "key": 53033006900,
    "Population": 5121,
    "White": "82%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "8%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "3%"
  },
  "53033007000": {
    "key": 53033007000,
    "Population": 7477,
    "White": "78%",
    "Black": "1%",
    "Native Am.": "1%",
    "Asian": "10%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "4%"
  },
  "53033007100": {
    "key": 53033007100,
    "Population": 5041,
    "White": "62%",
    "Black": "3%",
    "Native Am.": "3%",
    "Asian": "15%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "12%"
  },
  "53033007200": {
    "key": 53033007200,
    "Population": 10403,
    "White": "57%",
    "Black": "4%",
    "Native Am.": "1%",
    "Asian": "25%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "6%"
  },
  "53033007300": {
    "key": 53033007300,
    "Population": 7402,
    "White": "53%",
    "Black": "10%",
    "Native Am.": "0%",
    "Asian": "20%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "9%"
  },
  "53033007401": {
    "key": 53033007401,
    "Population": 5502,
    "White": "66%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "21%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "6%"
  },
  "53033007402": {
    "key": 53033007402,
    "Population": 5560,
    "White": "69%",
    "Black": "5%",
    "Native Am.": "0%",
    "Asian": "13%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "5%"
  },
  "53033007500": {
    "key": 53033007500,
    "Population": 9289,
    "White": "72%",
    "Black": "2%",
    "Native Am.": "3%",
    "Asian": "8%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "9%",
    "Hispanic": "6%"
  },
  "53033007600": {
    "key": 53033007600,
    "Population": 4389,
    "White": "74%",
    "Black": "4%",
    "Native Am.": "0%",
    "Asian": "9%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "7%"
  },
  "53033007700": {
    "key": 53033007700,
    "Population": 5382,
    "White": "67%",
    "Black": "13%",
    "Native Am.": "0%",
    "Asian": "7%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "8%",
    "Hispanic": "5%"
  },
  "53033007800": {
    "key": 53033007800,
    "Population": 5675,
    "White": "75%",
    "Black": "6%",
    "Native Am.": "0%",
    "Asian": "4%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "11%",
    "Hispanic": "4%"
  },
  "53033007900": {
    "key": 53033007900,
    "Population": 6228,
    "White": "68%",
    "Black": "15%",
    "Native Am.": "1%",
    "Asian": "6%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "5%"
  },
  "53033008001": {
    "key": 53033008001,
    "Population": 7182,
    "White": "62%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "25%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "6%"
  },
  "53033008002": {
    "key": 53033008002,
    "Population": 3688,
    "White": "63%",
    "Black": "9%",
    "Native Am.": "1%",
    "Asian": "16%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "6%"
  },
  "53033008100": {
    "key": 53033008100,
    "Population": 4706,
    "White": "62%",
    "Black": "9%",
    "Native Am.": "2%",
    "Asian": "13%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "7%"
  },
  "53033008200": {
    "key": 53033008200,
    "Population": 4286,
    "White": "70%",
    "Black": "6%",
    "Native Am.": "0%",
    "Asian": "17%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "5%"
  },
  "53033008300": {
    "key": 53033008300,
    "Population": 3265,
    "White": "66%",
    "Black": "5%",
    "Native Am.": "1%",
    "Asian": "19%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "1%",
    "Hispanic": "7%"
  },
  "53033008400": {
    "key": 53033008400,
    "Population": 4865,
    "White": "65%",
    "Black": "8%",
    "Native Am.": "0%",
    "Asian": "18%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "5%"
  },
  "53033008500": {
    "key": 53033008500,
    "Population": 4195,
    "White": "50%",
    "Black": "16%",
    "Native Am.": "1%",
    "Asian": "14%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "10%"
  },
  "53033008600": {
    "key": 53033008600,
    "Population": 6079,
    "White": "52%",
    "Black": "8%",
    "Native Am.": "0%",
    "Asian": "18%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "16%"
  },
  "53033008700": {
    "key": 53033008700,
    "Population": 4573,
    "White": "52%",
    "Black": "19%",
    "Native Am.": "1%",
    "Asian": "8%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "11%",
    "Hispanic": "9%"
  },
  "53033008800": {
    "key": 53033008800,
    "Population": 4435,
    "White": "55%",
    "Black": "20%",
    "Native Am.": "0%",
    "Asian": "6%",
    "Pacific Isl.": "4%",
    "Other": "3%",
    "Multiracial": "7%",
    "Hispanic": "5%"
  },
  "53033008900": {
    "key": 53033008900,
    "Population": 6068,
    "White": "47%",
    "Black": "25%",
    "Native Am.": "1%",
    "Asian": "12%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "8%",
    "Hispanic": "7%"
  },
  "53033009000": {
    "key": 53033009000,
    "Population": 3457,
    "White": "33%",
    "Black": "30%",
    "Native Am.": "2%",
    "Asian": "23%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "8%",
    "Hispanic": "4%"
  },
  "53033009100": {
    "key": 53033009100,
    "Population": 2464,
    "White": "21%",
    "Black": "5%",
    "Native Am.": "3%",
    "Asian": "61%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "5%",
    "Hispanic": "4%"
  },
  "53033009200": {
    "key": 53033009200,
    "Population": 2763,
    "White": "47%",
    "Black": "9%",
    "Native Am.": "4%",
    "Asian": "24%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "7%",
    "Hispanic": "8%"
  },
  "53033009300": {
    "key": 53033009300,
    "Population": 2637,
    "White": "53%",
    "Black": "11%",
    "Native Am.": "2%",
    "Asian": "20%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "9%",
    "Hispanic": "5%"
  },
  "53033009400": {
    "key": 53033009400,
    "Population": 7243,
    "White": "32%",
    "Black": "9%",
    "Native Am.": "2%",
    "Asian": "26%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "24%"
  },
  "53033009500": {
    "key": 53033009500,
    "Population": 6517,
    "White": "65%",
    "Black": "14%",
    "Native Am.": "0%",
    "Asian": "11%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "6%",
    "Hispanic": "3%"
  },
  "53033009600": {
    "key": 53033009600,
    "Population": 5663,
    "White": "83%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "6%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "5%"
  },
  "53033009701": {
    "key": 53033009701,
    "Population": 6233,
    "White": "78%",
    "Black": "1%",
    "Native Am.": "1%",
    "Asian": "6%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "8%"
  },
  "53033009702": {
    "key": 53033009702,
    "Population": 5596,
    "White": "82%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "4%",
    "Pacific Isl.": "0%",
    "Other": "2%",
    "Multiracial": "6%",
    "Hispanic": "4%"
  },
  "53033009800": {
    "key": 53033009800,
    "Population": 7201,
    "White": "81%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "6%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "6%"
  },
  "53033009900": {
    "key": 53033009900,
    "Population": 6180,
    "White": "73%",
    "Black": "3%",
    "Native Am.": "0%",
    "Asian": "10%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "8%"
  },
  "53033010001": {
    "key": 53033010001,
    "Population": 4516,
    "White": "34%",
    "Black": "29%",
    "Native Am.": "0%",
    "Asian": "27%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "7%"
  },
  "53033010002": {
    "key": 53033010002,
    "Population": 4925,
    "White": "40%",
    "Black": "6%",
    "Native Am.": "0%",
    "Asian": "30%",
    "Pacific Isl.": "0%",
    "Other": "2%",
    "Multiracial": "6%",
    "Hispanic": "16%"
  },
  "53033010100": {
    "key": 53033010100,
    "Population": 8943,
    "White": "37%",
    "Black": "27%",
    "Native Am.": "0%",
    "Asian": "20%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "8%"
  },
  "53033010200": {
    "key": 53033010200,
    "Population": 4762,
    "White": "63%",
    "Black": "12%",
    "Native Am.": "0%",
    "Asian": "17%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "4%",
    "Hispanic": "3%"
  },
  "53033010300": {
    "key": 53033010300,
    "Population": 7305,
    "White": "39%",
    "Black": "32%",
    "Native Am.": "1%",
    "Asian": "19%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "3%"
  },
  "53033010401": {
    "key": 53033010401,
    "Population": 4382,
    "White": "21%",
    "Black": "12%",
    "Native Am.": "0%",
    "Asian": "53%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "11%"
  },
  "53033010402": {
    "key": 53033010402,
    "Population": 4933,
    "White": "26%",
    "Black": "4%",
    "Native Am.": "0%",
    "Asian": "52%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "8%",
    "Hispanic": "9%"
  },
  "53033010500": {
    "key": 53033010500,
    "Population": 8303,
    "White": "77%",
    "Black": "2%",
    "Native Am.": "1%",
    "Asian": "8%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "8%",
    "Hispanic": "4%"
  },
  "53033010600": {
    "key": 53033010600,
    "Population": 8466,
    "White": "77%",
    "Black": "3%",
    "Native Am.": "1%",
    "Asian": "7%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "8%"
  },
  "53033010701": {
    "key": 53033010701,
    "Population": 3907,
    "White": "42%",
    "Black": "28%",
    "Native Am.": "0%",
    "Asian": "13%",
    "Pacific Isl.": "3%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "9%"
  },
  "53033010702": {
    "key": 53033010702,
    "Population": 4930,
    "White": "32%",
    "Black": "29%",
    "Native Am.": "0%",
    "Asian": "24%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "9%"
  },
  "53033010800": {
    "key": 53033010800,
    "Population": 4862,
    "White": "49%",
    "Black": "12%",
    "Native Am.": "0%",
    "Asian": "23%",
    "Pacific Isl.": "2%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "9%"
  },
  "53033010900": {
    "key": 53033010900,
    "Population": 1115,
    "White": "72%",
    "Black": "7%",
    "Native Am.": "1%",
    "Asian": "2%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "13%"
  },
  "53033011001": {
    "key": 53033011001,
    "Population": 4777,
    "White": "16%",
    "Black": "35%",
    "Native Am.": "0%",
    "Asian": "40%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "5%"
  },
  "53033011002": {
    "key": 53033011002,
    "Population": 4765,
    "White": "8%",
    "Black": "32%",
    "Native Am.": "2%",
    "Asian": "53%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "3%"
  },
  "53033011101": {
    "key": 53033011101,
    "Population": 5546,
    "White": "21%",
    "Black": "22%",
    "Native Am.": "0%",
    "Asian": "45%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "6%"
  },
  "53033011102": {
    "key": 53033011102,
    "Population": 4747,
    "White": "46%",
    "Black": "6%",
    "Native Am.": "0%",
    "Asian": "22%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "18%"
  },
  "53033011200": {
    "key": 53033011200,
    "Population": 3705,
    "White": "35%",
    "Black": "6%",
    "Native Am.": "2%",
    "Asian": "12%",
    "Pacific Isl.": "5%",
    "Other": "3%",
    "Multiracial": "8%",
    "Hispanic": "29%"
  },
  "53033011300": {
    "key": 53033011300,
    "Population": 6973,
    "White": "45%",
    "Black": "5%",
    "Native Am.": "0%",
    "Asian": "15%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "19%",
    "Hispanic": "16%"
  },
  "53033011401": {
    "key": 53033011401,
    "Population": 4347,
    "White": "48%",
    "Black": "17%",
    "Native Am.": "1%",
    "Asian": "13%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "15%"
  },
  "53033011402": {
    "key": 53033011402,
    "Population": 4316,
    "White": "39%",
    "Black": "11%",
    "Native Am.": "0%",
    "Asian": "15%",
    "Pacific Isl.": "1%",
    "Other": "2%",
    "Multiracial": "7%",
    "Hispanic": "24%"
  },
  "53033011500": {
    "key": 53033011500,
    "Population": 4509,
    "White": "77%",
    "Black": "5%",
    "Native Am.": "0%",
    "Asian": "10%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "3%"
  },
  "53033011600": {
    "key": 53033011600,
    "Population": 7049,
    "White": "89%",
    "Black": "1%",
    "Native Am.": "2%",
    "Asian": "2%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "5%"
  },
  "53033011700": {
    "key": 53033011700,
    "Population": 5379,
    "White": "13%",
    "Black": "27%",
    "Native Am.": "1%",
    "Asian": "41%",
    "Pacific Isl.": "3%",
    "Other": "0%",
    "Multiracial": "8%",
    "Hispanic": "7%"
  },
  "53033011800": {
    "key": 53033011800,
    "Population": 8520,
    "White": "19%",
    "Black": "31%",
    "Native Am.": "0%",
    "Asian": "23%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "13%",
    "Hispanic": "14%"
  },
  "53033011900": {
    "key": 53033011900,
    "Population": 7649,
    "White": "28%",
    "Black": "23%",
    "Native Am.": "1%",
    "Asian": "35%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "8%"
  },
  "53033012000": {
    "key": 53033012000,
    "Population": 3622,
    "White": "77%",
    "Black": "8%",
    "Native Am.": "1%",
    "Asian": "2%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "7%"
  },
  "53033012100": {
    "key": 53033012100,
    "Population": 2660,
    "White": "78%",
    "Black": "4%",
    "Native Am.": "0%",
    "Asian": "5%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "10%"
  },
  "53033020100": {
    "key": 53033020100,
    "Population": 3279,
    "White": "81%",
    "Black": "3%",
    "Native Am.": "1%",
    "Asian": "9%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "3%"
  },
  "53033020200": {
    "key": 53033020200,
    "Population": 5395,
    "White": "79%",
    "Black": "3%",
    "Native Am.": "0%",
    "Asian": "7%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "4%"
  },
  "53033020300": {
    "key": 53033020300,
    "Population": 7128,
    "White": "58%",
    "Black": "7%",
    "Native Am.": "0%",
    "Asian": "16%",
    "Pacific Isl.": "3%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "12%"
  },
  "53033020401": {
    "key": 53033020401,
    "Population": 3760,
    "White": "64%",
    "Black": "9%",
    "Native Am.": "2%",
    "Asian": "14%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "4%"
  },
  "53033020402": {
    "key": 53033020402,
    "Population": 5613,
    "White": "74%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "9%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "9%"
  },
  "53033020500": {
    "key": 53033020500,
    "Population": 6669,
    "White": "62%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "15%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "16%"
  },
  "53033020600": {
    "key": 53033020600,
    "Population": 3620,
    "White": "69%",
    "Black": "6%",
    "Native Am.": "1%",
    "Asian": "16%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "4%"
  },
  "53033020700": {
    "key": 53033020700,
    "Population": 3791,
    "White": "52%",
    "Black": "10%",
    "Native Am.": "0%",
    "Asian": "18%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "14%"
  },
  "53033020800": {
    "key": 53033020800,
    "Population": 4273,
    "White": "78%",
    "Black": "1%",
    "Native Am.": "1%",
    "Asian": "10%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "5%"
  },
  "53033020900": {
    "key": 53033020900,
    "Population": 3645,
    "White": "67%",
    "Black": "7%",
    "Native Am.": "0%",
    "Asian": "17%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "4%"
  },
  "53033021000": {
    "key": 53033021000,
    "Population": 6010,
    "White": "56%",
    "Black": "7%",
    "Native Am.": "1%",
    "Asian": "20%",
    "Pacific Isl.": "1%",
    "Other": "1%",
    "Multiracial": "6%",
    "Hispanic": "8%"
  },
  "53033021100": {
    "key": 53033021100,
    "Population": 4485,
    "White": "62%",
    "Black": "12%",
    "Native Am.": "0%",
    "Asian": "19%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "2%"
  },
  "53033021300": {
    "key": 53033021300,
    "Population": 4047,
    "White": "70%",
    "Black": "4%",
    "Native Am.": "0%",
    "Asian": "14%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "7%"
  },
  "53033021400": {
    "key": 53033021400,
    "Population": 4064,
    "White": "82%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "6%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "8%",
    "Hispanic": "2%"
  },
  "53033021500": {
    "key": 53033021500,
    "Population": 4611,
    "White": "80%",
    "Black": "3%",
    "Native Am.": "0%",
    "Asian": "8%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "4%",
    "Hispanic": "4%"
  },
  "53033021600": {
    "key": 53033021600,
    "Population": 5038,
    "White": "76%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "10%",
    "Pacific Isl.": "2%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "6%"
  },
  "53033021700": {
    "key": 53033021700,
    "Population": 8655,
    "White": "68%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "14%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "12%"
  },
  "53033021802": {
    "key": 53033021802,
    "Population": 5818,
    "White": "67%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "20%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "10%"
  },
  "53033021803": {
    "key": 53033021803,
    "Population": 4943,
    "White": "68%",
    "Black": "4%",
    "Native Am.": "0%",
    "Asian": "16%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "4%"
  },
  "53033021804": {
    "key": 53033021804,
    "Population": 5133,
    "White": "66%",
    "Black": "5%",
    "Native Am.": "0%",
    "Asian": "9%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "14%"
  },
  "53033021903": {
    "key": 53033021903,
    "Population": 6404,
    "White": "76%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "8%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "9%"
  },
  "53033021904": {
    "key": 53033021904,
    "Population": 5007,
    "White": "58%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "27%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "8%"
  },
  "53033021905": {
    "key": 53033021905,
    "Population": 5674,
    "White": "69%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "13%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "13%"
  },
  "53033021906": {
    "key": 53033021906,
    "Population": 4550,
    "White": "65%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "16%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "10%"
  },
  "53033022001": {
    "key": 53033022001,
    "Population": 5552,
    "White": "69%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "9%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "9%",
    "Hispanic": "11%"
  },
  "53033022003": {
    "key": 53033022003,
    "Population": 5069,
    "White": "67%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "12%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "8%",
    "Hispanic": "11%"
  },
  "53033022005": {
    "key": 53033022005,
    "Population": 4964,
    "White": "67%",
    "Black": "2%",
    "Native Am.": "1%",
    "Asian": "20%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "5%"
  },
  "53033022006": {
    "key": 53033022006,
    "Population": 3907,
    "White": "74%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "15%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "7%"
  },
  "53033022101": {
    "key": 53033022101,
    "Population": 4847,
    "White": "81%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "10%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "5%"
  },
  "53033022102": {
    "key": 53033022102,
    "Population": 6463,
    "White": "74%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "17%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "3%",
    "Hispanic": "6%"
  },
  "53033022201": {
    "key": 53033022201,
    "Population": 4430,
    "White": "77%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "10%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "6%"
  },
  "53033022202": {
    "key": 53033022202,
    "Population": 7509,
    "White": "73%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "17%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "6%"
  },
  "53033022203": {
    "key": 53033022203,
    "Population": 4918,
    "White": "79%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "12%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "4%"
  },
  "53033022300": {
    "key": 53033022300,
    "Population": 2779,
    "White": "80%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "7%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "6%",
    "Hispanic": "5%"
  },
  "53033022400": {
    "key": 53033022400,
    "Population": 8611,
    "White": "81%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "11%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "4%"
  },
  "53033022500": {
    "key": 53033022500,
    "Population": 8414,
    "White": "75%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "11%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "8%"
  },
  "53033022603": {
    "key": 53033022603,
    "Population": 6173,
    "White": "61%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "21%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "11%"
  },
  "53033022604": {
    "key": 53033022604,
    "Population": 5069,
    "White": "69%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "16%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "10%"
  },
  "53033022605": {
    "key": 53033022605,
    "Population": 6347,
    "White": "53%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "27%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "17%"
  },
  "53033022606": {
    "key": 53033022606,
    "Population": 6087,
    "White": "63%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "24%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "10%"
  },
  "53033022701": {
    "key": 53033022701,
    "Population": 3315,
    "White": "72%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "14%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "6%"
  },
  "53033022702": {
    "key": 53033022702,
    "Population": 4182,
    "White": "77%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "11%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "8%",
    "Hispanic": "3%"
  },
  "53033022703": {
    "key": 53033022703,
    "Population": 2357,
    "White": "66%",
    "Black": "5%",
    "Native Am.": "0%",
    "Asian": "20%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "5%"
  },
  "53033022801": {
    "key": 53033022801,
    "Population": 9233,
    "White": "34%",
    "Black": "3%",
    "Native Am.": "0%",
    "Asian": "53%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "6%"
  },
  "53033022802": {
    "key": 53033022802,
    "Population": 5340,
    "White": "62%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "30%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "3%"
  },
  "53033022803": {
    "key": 53033022803,
    "Population": 6083,
    "White": "31%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "51%",
    "Pacific Isl.": "3%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "11%"
  },
  "53033022901": {
    "key": 53033022901,
    "Population": 2992,
    "White": "62%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "29%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "2%"
  },
  "53033022902": {
    "key": 53033022902,
    "Population": 6573,
    "White": "61%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "33%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "1%"
  },
  "53033023000": {
    "key": 53033023000,
    "Population": 5718,
    "White": "64%",
    "Black": "3%",
    "Native Am.": "0%",
    "Asian": "21%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "5%"
  },
  "53033023100": {
    "key": 53033023100,
    "Population": 4143,
    "White": "55%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "26%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "9%",
    "Hispanic": "9%"
  },
  "53033023201": {
    "key": 53033023201,
    "Population": 6639,
    "White": "32%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "63%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "3%"
  },
  "53033023202": {
    "key": 53033023202,
    "Population": 4724,
    "White": "36%",
    "Black": "9%",
    "Native Am.": "0%",
    "Asian": "26%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "25%"
  },
  "53033023300": {
    "key": 53033023300,
    "Population": 6721,
    "White": "69%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "15%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "3%",
    "Hispanic": "11%"
  },
  "53033023401": {
    "key": 53033023401,
    "Population": 3980,
    "White": "48%",
    "Black": "2%",
    "Native Am.": "2%",
    "Asian": "33%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "9%"
  },
  "53033023403": {
    "key": 53033023403,
    "Population": 4257,
    "White": "67%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "24%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "4%"
  },
  "53033023404": {
    "key": 53033023404,
    "Population": 3438,
    "White": "81%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "11%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "6%"
  },
  "53033023500": {
    "key": 53033023500,
    "Population": 3788,
    "White": "51%",
    "Black": "3%",
    "Native Am.": "0%",
    "Asian": "33%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "7%",
    "Hispanic": "4%"
  },
  "53033023601": {
    "key": 53033023601,
    "Population": 4252,
    "White": "45%",
    "Black": "5%",
    "Native Am.": "0%",
    "Asian": "37%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "6%"
  },
  "53033023603": {
    "key": 53033023603,
    "Population": 6649,
    "White": "35%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "47%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "12%"
  },
  "53033023604": {
    "key": 53033023604,
    "Population": 6616,
    "White": "41%",
    "Black": "7%",
    "Native Am.": "0%",
    "Asian": "28%",
    "Pacific Isl.": "4%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "17%"
  },
  "53033023700": {
    "key": 53033023700,
    "Population": 4425,
    "White": "60%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "30%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "4%"
  },
  "53033023801": {
    "key": 53033023801,
    "Population": 3074,
    "White": "50%",
    "Black": "3%",
    "Native Am.": "0%",
    "Asian": "32%",
    "Pacific Isl.": "3%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "7%"
  },
  "53033023803": {
    "key": 53033023803,
    "Population": 5339,
    "White": "42%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "46%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "6%"
  },
  "53033023804": {
    "key": 53033023804,
    "Population": 7397,
    "White": "54%",
    "Black": "5%",
    "Native Am.": "0%",
    "Asian": "35%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "2%"
  },
  "53033023900": {
    "key": 53033023900,
    "Population": 7067,
    "White": "70%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "20%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "5%"
  },
  "53033024000": {
    "key": 53033024000,
    "Population": 7674,
    "White": "56%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "35%",
    "Pacific Isl.": "0%",
    "Other": "2%",
    "Multiracial": "4%",
    "Hispanic": "4%"
  },
  "53033024100": {
    "key": 53033024100,
    "Population": 4895,
    "White": "73%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "19%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "2%"
  },
  "53033024200": {
    "key": 53033024200,
    "Population": 3253,
    "White": "67%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "22%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "4%"
  },
  "53033024300": {
    "key": 53033024300,
    "Population": 8736,
    "White": "69%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "22%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "4%",
    "Hispanic": "2%"
  },
  "53033024400": {
    "key": 53033024400,
    "Population": 3117,
    "White": "62%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "24%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "10%"
  },
  "53033024500": {
    "key": 53033024500,
    "Population": 5195,
    "White": "72%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "18%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "4%"
  },
  "53033024601": {
    "key": 53033024601,
    "Population": 4573,
    "White": "76%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "18%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "1%"
  },
  "53033024602": {
    "key": 53033024602,
    "Population": 3871,
    "White": "78%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "16%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "4%"
  },
  "53033024701": {
    "key": 53033024701,
    "Population": 4068,
    "White": "46%",
    "Black": "7%",
    "Native Am.": "0%",
    "Asian": "35%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "8%"
  },
  "53033024702": {
    "key": 53033024702,
    "Population": 7732,
    "White": "60%",
    "Black": "5%",
    "Native Am.": "0%",
    "Asian": "29%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "3%"
  },
  "53033024800": {
    "key": 53033024800,
    "Population": 5990,
    "White": "38%",
    "Black": "6%",
    "Native Am.": "1%",
    "Asian": "29%",
    "Pacific Isl.": "0%",
    "Other": "3%",
    "Multiracial": "10%",
    "Hispanic": "12%"
  },
  "53033024901": {
    "key": 53033024901,
    "Population": 5428,
    "White": "43%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "52%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "2%"
  },
  "53033024902": {
    "key": 53033024902,
    "Population": 4065,
    "White": "50%",
    "Black": "3%",
    "Native Am.": "0%",
    "Asian": "34%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "7%",
    "Hispanic": "6%"
  },
  "53033024903": {
    "key": 53033024903,
    "Population": 7114,
    "White": "50%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "44%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "3%",
    "Hispanic": "2%"
  },
  "53033025001": {
    "key": 53033025001,
    "Population": 5127,
    "White": "61%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "29%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "6%"
  },
  "53033025003": {
    "key": 53033025003,
    "Population": 6863,
    "White": "58%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "32%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "1%",
    "Hispanic": "6%"
  },
  "53033025005": {
    "key": 53033025005,
    "Population": 5133,
    "White": "52%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "35%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "6%",
    "Hispanic": "5%"
  },
  "53033025006": {
    "key": 53033025006,
    "Population": 6164,
    "White": "62%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "29%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "3%"
  },
  "53033025101": {
    "key": 53033025101,
    "Population": 6675,
    "White": "54%",
    "Black": "5%",
    "Native Am.": "0%",
    "Asian": "24%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "12%"
  },
  "53033025102": {
    "key": 53033025102,
    "Population": 7878,
    "White": "43%",
    "Black": "5%",
    "Native Am.": "0%",
    "Asian": "33%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "9%",
    "Hispanic": "8%"
  },
  "53033025200": {
    "key": 53033025200,
    "Population": 8985,
    "White": "53%",
    "Black": "6%",
    "Native Am.": "0%",
    "Asian": "21%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "15%"
  },
  "53033025301": {
    "key": 53033025301,
    "Population": 6330,
    "White": "55%",
    "Black": "5%",
    "Native Am.": "0%",
    "Asian": "18%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "10%",
    "Hispanic": "13%"
  },
  "53033025302": {
    "key": 53033025302,
    "Population": 5583,
    "White": "41%",
    "Black": "18%",
    "Native Am.": "0%",
    "Asian": "11%",
    "Pacific Isl.": "7%",
    "Other": "1%",
    "Multiracial": "6%",
    "Hispanic": "16%"
  },
  "53033025400": {
    "key": 53033025400,
    "Population": 7445,
    "White": "45%",
    "Black": "11%",
    "Native Am.": "1%",
    "Asian": "14%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "24%"
  },
  "53033025500": {
    "key": 53033025500,
    "Population": 4794,
    "White": "49%",
    "Black": "6%",
    "Native Am.": "0%",
    "Asian": "21%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "1%",
    "Hispanic": "23%"
  },
  "53033025601": {
    "key": 53033025601,
    "Population": 5644,
    "White": "34%",
    "Black": "3%",
    "Native Am.": "0%",
    "Asian": "28%",
    "Pacific Isl.": "4%",
    "Other": "1%",
    "Multiracial": "5%",
    "Hispanic": "24%"
  },
  "53033025602": {
    "key": 53033025602,
    "Population": 6356,
    "White": "54%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "31%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "9%"
  },
  "53033025701": {
    "key": 53033025701,
    "Population": 6215,
    "White": "51%",
    "Black": "14%",
    "Native Am.": "2%",
    "Asian": "17%",
    "Pacific Isl.": "3%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "7%"
  },
  "53033025702": {
    "key": 53033025702,
    "Population": 3577,
    "White": "59%",
    "Black": "10%",
    "Native Am.": "0%",
    "Asian": "20%",
    "Pacific Isl.": "2%",
    "Other": "1%",
    "Multiracial": "4%",
    "Hispanic": "5%"
  },
  "53033025803": {
    "key": 53033025803,
    "Population": 4755,
    "White": "38%",
    "Black": "11%",
    "Native Am.": "0%",
    "Asian": "10%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "9%",
    "Hispanic": "31%"
  },
  "53033025804": {
    "key": 53033025804,
    "Population": 3614,
    "White": "55%",
    "Black": "6%",
    "Native Am.": "0%",
    "Asian": "15%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "9%",
    "Hispanic": "13%"
  },
  "53033025805": {
    "key": 53033025805,
    "Population": 5197,
    "White": "38%",
    "Black": "11%",
    "Native Am.": "1%",
    "Asian": "26%",
    "Pacific Isl.": "2%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "16%"
  },
  "53033025806": {
    "key": 53033025806,
    "Population": 5329,
    "White": "32%",
    "Black": "15%",
    "Native Am.": "1%",
    "Asian": "35%",
    "Pacific Isl.": "4%",
    "Other": "0%",
    "Multiracial": "10%",
    "Hispanic": "2%"
  },
  "53033026001": {
    "key": 53033026001,
    "Population": 5704,
    "White": "37%",
    "Black": "21%",
    "Native Am.": "0%",
    "Asian": "30%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "9%"
  },
  "53033026002": {
    "key": 53033026002,
    "Population": 8529,
    "White": "25%",
    "Black": "32%",
    "Native Am.": "0%",
    "Asian": "27%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "9%"
  },
  "53033026100": {
    "key": 53033026100,
    "Population": 8327,
    "White": "21%",
    "Black": "26%",
    "Native Am.": "1%",
    "Asian": "34%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "12%"
  },
  "53033026200": {
    "key": 53033026200,
    "Population": 5743,
    "White": "43%",
    "Black": "13%",
    "Native Am.": "2%",
    "Asian": "19%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "12%",
    "Hispanic": "11%"
  },
  "53033026300": {
    "key": 53033026300,
    "Population": 1616,
    "White": "29%",
    "Black": "4%",
    "Native Am.": "0%",
    "Asian": "37%",
    "Pacific Isl.": "14%",
    "Other": "0%",
    "Multiracial": "10%",
    "Hispanic": "6%"
  },
  "53033026400": {
    "key": 53033026400,
    "Population": 6198,
    "White": "35%",
    "Black": "15%",
    "Native Am.": "1%",
    "Asian": "12%",
    "Pacific Isl.": "4%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "31%"
  },
  "53033026500": {
    "key": 53033026500,
    "Population": 4392,
    "White": "30%",
    "Black": "20%",
    "Native Am.": "0%",
    "Asian": "19%",
    "Pacific Isl.": "2%",
    "Other": "0%",
    "Multiracial": "9%",
    "Hispanic": "19%"
  },
  "53033026600": {
    "key": 53033026600,
    "Population": 2538,
    "White": "48%",
    "Black": "9%",
    "Native Am.": "1%",
    "Asian": "16%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "9%",
    "Hispanic": "17%"
  },
  "53033026700": {
    "key": 53033026700,
    "Population": 5291,
    "White": "56%",
    "Black": "4%",
    "Native Am.": "2%",
    "Asian": "8%",
    "Pacific Isl.": "7%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "19%"
  },
  "53033026801": {
    "key": 53033026801,
    "Population": 5883,
    "White": "40%",
    "Black": "10%",
    "Native Am.": "1%",
    "Asian": "8%",
    "Pacific Isl.": "5%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "31%"
  },
  "53033026802": {
    "key": 53033026802,
    "Population": 5562,
    "White": "33%",
    "Black": "9%",
    "Native Am.": "0%",
    "Asian": "22%",
    "Pacific Isl.": "4%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "27%"
  },
  "53033027000": {
    "key": 53033027000,
    "Population": 3147,
    "White": "50%",
    "Black": "5%",
    "Native Am.": "2%",
    "Asian": "16%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "1%",
    "Hispanic": "25%"
  },
  "53033027100": {
    "key": 53033027100,
    "Population": 3885,
    "White": "36%",
    "Black": "16%",
    "Native Am.": "0%",
    "Asian": "15%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "1%",
    "Hispanic": "31%"
  },
  "53033027200": {
    "key": 53033027200,
    "Population": 2607,
    "White": "35%",
    "Black": "16%",
    "Native Am.": "0%",
    "Asian": "18%",
    "Pacific Isl.": "0%",
    "Other": "4%",
    "Multiracial": "5%",
    "Hispanic": "22%"
  },
  "53033027300": {
    "key": 53033027300,
    "Population": 5786,
    "White": "28%",
    "Black": "12%",
    "Native Am.": "1%",
    "Asian": "32%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "22%"
  },
  "53033027400": {
    "key": 53033027400,
    "Population": 5224,
    "White": "41%",
    "Black": "4%",
    "Native Am.": "0%",
    "Asian": "24%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "23%"
  },
  "53033027500": {
    "key": 53033027500,
    "Population": 4852,
    "White": "50%",
    "Black": "4%",
    "Native Am.": "1%",
    "Asian": "12%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "8%",
    "Hispanic": "25%"
  },
  "53033027600": {
    "key": 53033027600,
    "Population": 4757,
    "White": "53%",
    "Black": "6%",
    "Native Am.": "1%",
    "Asian": "7%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "1%",
    "Hispanic": "31%"
  },
  "53033027701": {
    "key": 53033027701,
    "Population": 5008,
    "White": "89%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "1%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "1%",
    "Hispanic": "8%"
  },
  "53033027702": {
    "key": 53033027702,
    "Population": 5028,
    "White": "96%",
    "Black": "0%",
    "Native Am.": "1%",
    "Asian": "2%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "0%",
    "Hispanic": "1%"
  },
  "53033027800": {
    "key": 53033027800,
    "Population": 3403,
    "White": "91%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "3%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "3%"
  },
  "53033027900": {
    "key": 53033027900,
    "Population": 7955,
    "White": "56%",
    "Black": "8%",
    "Native Am.": "0%",
    "Asian": "9%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "8%",
    "Hispanic": "19%"
  },
  "53033028000": {
    "key": 53033028000,
    "Population": 4554,
    "White": "29%",
    "Black": "17%",
    "Native Am.": "1%",
    "Asian": "16%",
    "Pacific Isl.": "4%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "29%"
  },
  "53033028100": {
    "key": 53033028100,
    "Population": 2649,
    "White": "22%",
    "Black": "35%",
    "Native Am.": "3%",
    "Asian": "21%",
    "Pacific Isl.": "2%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "11%"
  },
  "53033028200": {
    "key": 53033028200,
    "Population": 4929,
    "White": "32%",
    "Black": "25%",
    "Native Am.": "0%",
    "Asian": "14%",
    "Pacific Isl.": "2%",
    "Other": "2%",
    "Multiracial": "7%",
    "Hispanic": "18%"
  },
  "53033028300": {
    "key": 53033028300,
    "Population": 5241,
    "White": "42%",
    "Black": "13%",
    "Native Am.": "1%",
    "Asian": "28%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "10%"
  },
  "53033028402": {
    "key": 53033028402,
    "Population": 5254,
    "White": "29%",
    "Black": "31%",
    "Native Am.": "0%",
    "Asian": "18%",
    "Pacific Isl.": "3%",
    "Other": "0%",
    "Multiracial": "9%",
    "Hispanic": "10%"
  },
  "53033028403": {
    "key": 53033028403,
    "Population": 5379,
    "White": "32%",
    "Black": "25%",
    "Native Am.": "1%",
    "Asian": "9%",
    "Pacific Isl.": "8%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "19%"
  },
  "53033028500": {
    "key": 53033028500,
    "Population": 4263,
    "White": "48%",
    "Black": "11%",
    "Native Am.": "0%",
    "Asian": "12%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "22%"
  },
  "53033028600": {
    "key": 53033028600,
    "Population": 6556,
    "White": "82%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "9%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "5%"
  },
  "53033028700": {
    "key": 53033028700,
    "Population": 5205,
    "White": "69%",
    "Black": "3%",
    "Native Am.": "0%",
    "Asian": "8%",
    "Pacific Isl.": "3%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "12%"
  },
  "53033028801": {
    "key": 53033028801,
    "Population": 3260,
    "White": "51%",
    "Black": "6%",
    "Native Am.": "1%",
    "Asian": "9%",
    "Pacific Isl.": "4%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "23%"
  },
  "53033028802": {
    "key": 53033028802,
    "Population": 6631,
    "White": "27%",
    "Black": "29%",
    "Native Am.": "0%",
    "Asian": "13%",
    "Pacific Isl.": "5%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "20%"
  },
  "53033028901": {
    "key": 53033028901,
    "Population": 3304,
    "White": "69%",
    "Black": "3%",
    "Native Am.": "1%",
    "Asian": "4%",
    "Pacific Isl.": "3%",
    "Other": "0%",
    "Multiracial": "9%",
    "Hispanic": "12%"
  },
  "53033028902": {
    "key": 53033028902,
    "Population": 7525,
    "White": "27%",
    "Black": "13%",
    "Native Am.": "0%",
    "Asian": "12%",
    "Pacific Isl.": "7%",
    "Other": "1%",
    "Multiracial": "5%",
    "Hispanic": "34%"
  },
  "53033029001": {
    "key": 53033029001,
    "Population": 4574,
    "White": "65%",
    "Black": "5%",
    "Native Am.": "0%",
    "Asian": "11%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "8%",
    "Hispanic": "11%"
  },
  "53033029003": {
    "key": 53033029003,
    "Population": 5493,
    "White": "42%",
    "Black": "9%",
    "Native Am.": "1%",
    "Asian": "23%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "21%"
  },
  "53033029004": {
    "key": 53033029004,
    "Population": 4078,
    "White": "32%",
    "Black": "14%",
    "Native Am.": "2%",
    "Asian": "7%",
    "Pacific Isl.": "2%",
    "Other": "0%",
    "Multiracial": "1%",
    "Hispanic": "42%"
  },
  "53033029101": {
    "key": 53033029101,
    "Population": 3096,
    "White": "42%",
    "Black": "21%",
    "Native Am.": "0%",
    "Asian": "21%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "8%",
    "Hispanic": "8%"
  },
  "53033029102": {
    "key": 53033029102,
    "Population": 4324,
    "White": "45%",
    "Black": "14%",
    "Native Am.": "0%",
    "Asian": "8%",
    "Pacific Isl.": "10%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "18%"
  },
  "53033029203": {
    "key": 53033029203,
    "Population": 4244,
    "White": "38%",
    "Black": "12%",
    "Native Am.": "2%",
    "Asian": "9%",
    "Pacific Isl.": "3%",
    "Other": "0%",
    "Multiracial": "10%",
    "Hispanic": "27%"
  },
  "53033029204": {
    "key": 53033029204,
    "Population": 7360,
    "White": "40%",
    "Black": "9%",
    "Native Am.": "5%",
    "Asian": "17%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "23%"
  },
  "53033029205": {
    "key": 53033029205,
    "Population": 4659,
    "White": "46%",
    "Black": "11%",
    "Native Am.": "0%",
    "Asian": "16%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "23%"
  },
  "53033029206": {
    "key": 53033029206,
    "Population": 4409,
    "White": "30%",
    "Black": "15%",
    "Native Am.": "0%",
    "Asian": "8%",
    "Pacific Isl.": "9%",
    "Other": "0%",
    "Multiracial": "8%",
    "Hispanic": "31%"
  },
  "53033029303": {
    "key": 53033029303,
    "Population": 7473,
    "White": "44%",
    "Black": "11%",
    "Native Am.": "0%",
    "Asian": "25%",
    "Pacific Isl.": "5%",
    "Other": "1%",
    "Multiracial": "7%",
    "Hispanic": "7%"
  },
  "53033029304": {
    "key": 53033029304,
    "Population": 5237,
    "White": "53%",
    "Black": "8%",
    "Native Am.": "1%",
    "Asian": "25%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "9%"
  },
  "53033029305": {
    "key": 53033029305,
    "Population": 4256,
    "White": "44%",
    "Black": "13%",
    "Native Am.": "0%",
    "Asian": "25%",
    "Pacific Isl.": "5%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "11%"
  },
  "53033029306": {
    "key": 53033029306,
    "Population": 3651,
    "White": "51%",
    "Black": "4%",
    "Native Am.": "0%",
    "Asian": "33%",
    "Pacific Isl.": "2%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "6%"
  },
  "53033029307": {
    "key": 53033029307,
    "Population": 4244,
    "White": "65%",
    "Black": "2%",
    "Native Am.": "3%",
    "Asian": "24%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "2%"
  },
  "53033029403": {
    "key": 53033029403,
    "Population": 5876,
    "White": "38%",
    "Black": "14%",
    "Native Am.": "0%",
    "Asian": "33%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "12%"
  },
  "53033029405": {
    "key": 53033029405,
    "Population": 5690,
    "White": "55%",
    "Black": "6%",
    "Native Am.": "0%",
    "Asian": "24%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "8%"
  },
  "53033029406": {
    "key": 53033029406,
    "Population": 5174,
    "White": "43%",
    "Black": "10%",
    "Native Am.": "1%",
    "Asian": "36%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "6%"
  },
  "53033029407": {
    "key": 53033029407,
    "Population": 4639,
    "White": "46%",
    "Black": "11%",
    "Native Am.": "0%",
    "Asian": "22%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "14%"
  },
  "53033029408": {
    "key": 53033029408,
    "Population": 3993,
    "White": "33%",
    "Black": "9%",
    "Native Am.": "0%",
    "Asian": "19%",
    "Pacific Isl.": "2%",
    "Other": "1%",
    "Multiracial": "5%",
    "Hispanic": "31%"
  },
  "53033029502": {
    "key": 53033029502,
    "Population": 7516,
    "White": "48%",
    "Black": "11%",
    "Native Am.": "1%",
    "Asian": "30%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "4%"
  },
  "53033029503": {
    "key": 53033029503,
    "Population": 8828,
    "White": "34%",
    "Black": "20%",
    "Native Am.": "0%",
    "Asian": "23%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "19%"
  },
  "53033029504": {
    "key": 53033029504,
    "Population": 6103,
    "White": "32%",
    "Black": "19%",
    "Native Am.": "0%",
    "Asian": "18%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "10%",
    "Hispanic": "20%"
  },
  "53033029601": {
    "key": 53033029601,
    "Population": 7134,
    "White": "40%",
    "Black": "19%",
    "Native Am.": "1%",
    "Asian": "24%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "8%",
    "Hispanic": "7%"
  },
  "53033029602": {
    "key": 53033029602,
    "Population": 6235,
    "White": "63%",
    "Black": "4%",
    "Native Am.": "0%",
    "Asian": "21%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "6%"
  },
  "53033029700": {
    "key": 53033029700,
    "Population": 8219,
    "White": "54%",
    "Black": "10%",
    "Native Am.": "1%",
    "Asian": "11%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "21%"
  },
  "53033029801": {
    "key": 53033029801,
    "Population": 9944,
    "White": "51%",
    "Black": "9%",
    "Native Am.": "0%",
    "Asian": "10%",
    "Pacific Isl.": "5%",
    "Other": "0%",
    "Multiracial": "8%",
    "Hispanic": "16%"
  },
  "53033029802": {
    "key": 53033029802,
    "Population": 9213,
    "White": "55%",
    "Black": "6%",
    "Native Am.": "1%",
    "Asian": "15%",
    "Pacific Isl.": "2%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "18%"
  },
  "53033029901": {
    "key": 53033029901,
    "Population": 4725,
    "White": "63%",
    "Black": "8%",
    "Native Am.": "0%",
    "Asian": "14%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "9%"
  },
  "53033029902": {
    "key": 53033029902,
    "Population": 4226,
    "White": "65%",
    "Black": "7%",
    "Native Am.": "0%",
    "Asian": "13%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "8%",
    "Hispanic": "5%"
  },
  "53033030003": {
    "key": 53033030003,
    "Population": 6309,
    "White": "47%",
    "Black": "13%",
    "Native Am.": "0%",
    "Asian": "9%",
    "Pacific Isl.": "1%",
    "Other": "1%",
    "Multiracial": "7%",
    "Hispanic": "21%"
  },
  "53033030004": {
    "key": 53033030004,
    "Population": 8736,
    "White": "28%",
    "Black": "20%",
    "Native Am.": "0%",
    "Asian": "11%",
    "Pacific Isl.": "8%",
    "Other": "1%",
    "Multiracial": "5%",
    "Hispanic": "27%"
  },
  "53033030005": {
    "key": 53033030005,
    "Population": 5923,
    "White": "31%",
    "Black": "11%",
    "Native Am.": "0%",
    "Asian": "14%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "40%"
  },
  "53033030006": {
    "key": 53033030006,
    "Population": 4000,
    "White": "30%",
    "Black": "19%",
    "Native Am.": "0%",
    "Asian": "13%",
    "Pacific Isl.": "6%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "31%"
  },
  "53033030100": {
    "key": 53033030100,
    "Population": 7711,
    "White": "72%",
    "Black": "7%",
    "Native Am.": "2%",
    "Asian": "5%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "11%"
  },
  "53033030201": {
    "key": 53033030201,
    "Population": 5391,
    "White": "54%",
    "Black": "8%",
    "Native Am.": "1%",
    "Asian": "11%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "19%"
  },
  "53033030202": {
    "key": 53033030202,
    "Population": 6970,
    "White": "43%",
    "Black": "15%",
    "Native Am.": "0%",
    "Asian": "14%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "11%",
    "Hispanic": "17%"
  },
  "53033030304": {
    "key": 53033030304,
    "Population": 3868,
    "White": "49%",
    "Black": "11%",
    "Native Am.": "0%",
    "Asian": "18%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "1%",
    "Hispanic": "18%"
  },
  "53033030305": {
    "key": 53033030305,
    "Population": 5273,
    "White": "60%",
    "Black": "9%",
    "Native Am.": "1%",
    "Asian": "18%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "10%"
  },
  "53033030306": {
    "key": 53033030306,
    "Population": 5527,
    "White": "56%",
    "Black": "11%",
    "Native Am.": "2%",
    "Asian": "12%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "12%"
  },
  "53033030308": {
    "key": 53033030308,
    "Population": 7029,
    "White": "43%",
    "Black": "11%",
    "Native Am.": "1%",
    "Asian": "11%",
    "Pacific Isl.": "8%",
    "Other": "1%",
    "Multiracial": "8%",
    "Hispanic": "18%"
  },
  "53033030309": {
    "key": 53033030309,
    "Population": 5783,
    "White": "43%",
    "Black": "21%",
    "Native Am.": "1%",
    "Asian": "14%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "9%",
    "Hispanic": "11%"
  },
  "53033030310": {
    "key": 53033030310,
    "Population": 6298,
    "White": "42%",
    "Black": "8%",
    "Native Am.": "0%",
    "Asian": "25%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "11%",
    "Hispanic": "13%"
  },
  "53033030311": {
    "key": 53033030311,
    "Population": 5311,
    "White": "43%",
    "Black": "9%",
    "Native Am.": "0%",
    "Asian": "11%",
    "Pacific Isl.": "2%",
    "Other": "1%",
    "Multiracial": "6%",
    "Hispanic": "28%"
  },
  "53033030312": {
    "key": 53033030312,
    "Population": 4777,
    "White": "49%",
    "Black": "11%",
    "Native Am.": "1%",
    "Asian": "9%",
    "Pacific Isl.": "6%",
    "Other": "0%",
    "Multiracial": "8%",
    "Hispanic": "16%"
  },
  "53033030313": {
    "key": 53033030313,
    "Population": 4511,
    "White": "38%",
    "Black": "18%",
    "Native Am.": "0%",
    "Asian": "11%",
    "Pacific Isl.": "6%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "22%"
  },
  "53033030314": {
    "key": 53033030314,
    "Population": 4438,
    "White": "40%",
    "Black": "20%",
    "Native Am.": "0%",
    "Asian": "20%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "14%"
  },
  "53033030401": {
    "key": 53033030401,
    "Population": 9689,
    "White": "64%",
    "Black": "10%",
    "Native Am.": "2%",
    "Asian": "6%",
    "Pacific Isl.": "2%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "9%"
  },
  "53033030403": {
    "key": 53033030403,
    "Population": 4472,
    "White": "69%",
    "Black": "3%",
    "Native Am.": "1%",
    "Asian": "18%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "7%"
  },
  "53033030404": {
    "key": 53033030404,
    "Population": 4961,
    "White": "77%",
    "Black": "2%",
    "Native Am.": "2%",
    "Asian": "5%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "4%",
    "Hispanic": "10%"
  },
  "53033030501": {
    "key": 53033030501,
    "Population": 1907,
    "White": "63%",
    "Black": "6%",
    "Native Am.": "0%",
    "Asian": "8%",
    "Pacific Isl.": "8%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "7%"
  },
  "53033030503": {
    "key": 53033030503,
    "Population": 5802,
    "White": "60%",
    "Black": "9%",
    "Native Am.": "1%",
    "Asian": "7%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "17%"
  },
  "53033030504": {
    "key": 53033030504,
    "Population": 4690,
    "White": "53%",
    "Black": "10%",
    "Native Am.": "3%",
    "Asian": "9%",
    "Pacific Isl.": "2%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "17%"
  },
  "53033030600": {
    "key": 53033030600,
    "Population": 5592,
    "White": "55%",
    "Black": "1%",
    "Native Am.": "2%",
    "Asian": "10%",
    "Pacific Isl.": "1%",
    "Other": "1%",
    "Multiracial": "4%",
    "Hispanic": "25%"
  },
  "53033030700": {
    "key": 53033030700,
    "Population": 4101,
    "White": "56%",
    "Black": "11%",
    "Native Am.": "1%",
    "Asian": "7%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "10%",
    "Hispanic": "15%"
  },
  "53033030801": {
    "key": 53033030801,
    "Population": 7091,
    "White": "36%",
    "Black": "5%",
    "Native Am.": "2%",
    "Asian": "3%",
    "Pacific Isl.": "4%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "47%"
  },
  "53033030802": {
    "key": 53033030802,
    "Population": 3588,
    "White": "56%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "7%",
    "Pacific Isl.": "12%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "21%"
  },
  "53033030901": {
    "key": 53033030901,
    "Population": 3583,
    "White": "56%",
    "Black": "5%",
    "Native Am.": "1%",
    "Asian": "13%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "20%"
  },
  "53033030902": {
    "key": 53033030902,
    "Population": 6455,
    "White": "48%",
    "Black": "4%",
    "Native Am.": "0%",
    "Asian": "17%",
    "Pacific Isl.": "2%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "22%"
  },
  "53033031000": {
    "key": 53033031000,
    "Population": 4247,
    "White": "74%",
    "Black": "4%",
    "Native Am.": "0%",
    "Asian": "11%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "6%"
  },
  "53033031100": {
    "key": 53033031100,
    "Population": 7701,
    "White": "52%",
    "Black": "5%",
    "Native Am.": "5%",
    "Asian": "4%",
    "Pacific Isl.": "6%",
    "Other": "0%",
    "Multiracial": "8%",
    "Hispanic": "20%"
  },
  "53033031202": {
    "key": 53033031202,
    "Population": 6310,
    "White": "67%",
    "Black": "1%",
    "Native Am.": "17%",
    "Asian": "0%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "9%"
  },
  "53033031204": {
    "key": 53033031204,
    "Population": 5976,
    "White": "82%",
    "Black": "0%",
    "Native Am.": "1%",
    "Asian": "4%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "8%"
  },
  "53033031205": {
    "key": 53033031205,
    "Population": 7252,
    "White": "51%",
    "Black": "4%",
    "Native Am.": "1%",
    "Asian": "19%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "10%",
    "Hispanic": "15%"
  },
  "53033031206": {
    "key": 53033031206,
    "Population": 5475,
    "White": "56%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "21%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "16%"
  },
  "53033031301": {
    "key": 53033031301,
    "Population": 2670,
    "White": "76%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "1%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "17%"
  },
  "53033031302": {
    "key": 53033031302,
    "Population": 4253,
    "White": "85%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "0%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "11%"
  },
  "53033031400": {
    "key": 53033031400,
    "Population": 5943,
    "White": "82%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "2%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "12%"
  },
  "53033031501": {
    "key": 53033031501,
    "Population": 4083,
    "White": "87%",
    "Black": "0%",
    "Native Am.": "1%",
    "Asian": "3%",
    "Pacific Isl.": "2%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "2%"
  },
  "53033031502": {
    "key": 53033031502,
    "Population": 4219,
    "White": "89%",
    "Black": "0%",
    "Native Am.": "3%",
    "Asian": "1%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "4%"
  },
  "53033031601": {
    "key": 53033031601,
    "Population": 5573,
    "White": "79%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "5%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "10%"
  },
  "53033031603": {
    "key": 53033031603,
    "Population": 6515,
    "White": "83%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "4%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "6%"
  },
  "53033031604": {
    "key": 53033031604,
    "Population": 5777,
    "White": "76%",
    "Black": "2%",
    "Native Am.": "1%",
    "Asian": "7%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "8%",
    "Hispanic": "6%"
  },
  "53033031605": {
    "key": 53033031605,
    "Population": 4200,
    "White": "82%",
    "Black": "1%",
    "Native Am.": "2%",
    "Asian": "2%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "9%"
  },
  "53033031703": {
    "key": 53033031703,
    "Population": 6829,
    "White": "68%",
    "Black": "5%",
    "Native Am.": "1%",
    "Asian": "14%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "10%"
  },
  "53033031704": {
    "key": 53033031704,
    "Population": 5728,
    "White": "53%",
    "Black": "9%",
    "Native Am.": "0%",
    "Asian": "18%",
    "Pacific Isl.": "1%",
    "Other": "1%",
    "Multiracial": "4%",
    "Hispanic": "14%"
  },
  "53033031705": {
    "key": 53033031705,
    "Population": 4271,
    "White": "69%",
    "Black": "5%",
    "Native Am.": "1%",
    "Asian": "14%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "5%"
  },
  "53033031706": {
    "key": 53033031706,
    "Population": 7884,
    "White": "59%",
    "Black": "5%",
    "Native Am.": "0%",
    "Asian": "16%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "8%",
    "Hispanic": "12%"
  },
  "53033031800": {
    "key": 53033031800,
    "Population": 4719,
    "White": "69%",
    "Black": "6%",
    "Native Am.": "0%",
    "Asian": "16%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "3%"
  },
  "53033031903": {
    "key": 53033031903,
    "Population": 6801,
    "White": "74%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "11%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "6%"
  },
  "53033031904": {
    "key": 53033031904,
    "Population": 3417,
    "White": "87%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "2%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "5%"
  },
  "53033031906": {
    "key": 53033031906,
    "Population": 3958,
    "White": "80%",
    "Black": "3%",
    "Native Am.": "0%",
    "Asian": "11%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "1%"
  },
  "53033031907": {
    "key": 53033031907,
    "Population": 8159,
    "White": "52%",
    "Black": "5%",
    "Native Am.": "1%",
    "Asian": "20%",
    "Pacific Isl.": "1%",
    "Other": "1%",
    "Multiracial": "11%",
    "Hispanic": "9%"
  },
  "53033031908": {
    "key": 53033031908,
    "Population": 4375,
    "White": "63%",
    "Black": "14%",
    "Native Am.": "0%",
    "Asian": "7%",
    "Pacific Isl.": "1%",
    "Other": "1%",
    "Multiracial": "5%",
    "Hispanic": "9%"
  },
  "53033031909": {
    "key": 53033031909,
    "Population": 3080,
    "White": "68%",
    "Black": "7%",
    "Native Am.": "0%",
    "Asian": "19%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "3%"
  },
  "53033032002": {
    "key": 53033032002,
    "Population": 3191,
    "White": "94%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "1%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "3%"
  },
  "53033032003": {
    "key": 53033032003,
    "Population": 5547,
    "White": "89%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "1%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "3%",
    "Hispanic": "6%"
  },
  "53033032005": {
    "key": 53033032005,
    "Population": 6877,
    "White": "78%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "8%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "6%"
  },
  "53033032006": {
    "key": 53033032006,
    "Population": 5612,
    "White": "85%",
    "Black": "2%",
    "Native Am.": "1%",
    "Asian": "3%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "4%"
  },
  "53033032007": {
    "key": 53033032007,
    "Population": 3385,
    "White": "84%",
    "Black": "4%",
    "Native Am.": "0%",
    "Asian": "2%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "5%"
  },
  "53033032008": {
    "key": 53033032008,
    "Population": 4658,
    "White": "83%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "2%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "9%"
  },
  "53033032010": {
    "key": 53033032010,
    "Population": 6071,
    "White": "81%",
    "Black": "0%",
    "Native Am.": "1%",
    "Asian": "4%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "8%"
  },
  "53033032011": {
    "key": 53033032011,
    "Population": 4435,
    "White": "85%",
    "Black": "1%",
    "Native Am.": "1%",
    "Asian": "4%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "2%"
  },
  "53033032102": {
    "key": 53033032102,
    "Population": 5150,
    "White": "89%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "3%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "5%"
  },
  "53033032103": {
    "key": 53033032103,
    "Population": 5397,
    "White": "72%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "10%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "14%"
  },
  "53033032104": {
    "key": 53033032104,
    "Population": 6172,
    "White": "73%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "8%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "16%"
  },
  "53033032203": {
    "key": 53033032203,
    "Population": 8032,
    "White": "62%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "30%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "2%",
    "Hispanic": "4%"
  },
  "53033032207": {
    "key": 53033032207,
    "Population": 3930,
    "White": "74%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "18%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "3%"
  },
  "53033032208": {
    "key": 53033032208,
    "Population": 9764,
    "White": "67%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "21%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "7%"
  },
  "53033032210": {
    "key": 53033032210,
    "Population": 14540,
    "White": "54%",
    "Black": "5%",
    "Native Am.": "0%",
    "Asian": "27%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "8%"
  },
  "53033032211": {
    "key": 53033032211,
    "Population": 5124,
    "White": "58%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "29%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "4%"
  },
  "53033032212": {
    "key": 53033032212,
    "Population": 8337,
    "White": "56%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "35%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "3%",
    "Hispanic": "5%"
  },
  "53033032213": {
    "key": 53033032213,
    "Population": 4337,
    "White": "69%",
    "Black": "4%",
    "Native Am.": "0%",
    "Asian": "23%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "3%"
  },
  "53033032214": {
    "key": 53033032214,
    "Population": 6706,
    "White": "50%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "42%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "4%"
  },
  "53033032215": {
    "key": 53033032215,
    "Population": 5034,
    "White": "53%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "41%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "3%"
  },
  "53033032307": {
    "key": 53033032307,
    "Population": 6093,
    "White": "85%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "6%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "3%"
  },
  "53033032309": {
    "key": 53033032309,
    "Population": 8249,
    "White": "50%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "36%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "5%"
  },
  "53033032311": {
    "key": 53033032311,
    "Population": 6730,
    "White": "83%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "4%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "6%",
    "Hispanic": "6%"
  },
  "53033032313": {
    "key": 53033032313,
    "Population": 6551,
    "White": "37%",
    "Black": "3%",
    "Native Am.": "0%",
    "Asian": "53%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "5%"
  },
  "53033032315": {
    "key": 53033032315,
    "Population": 5280,
    "White": "84%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "7%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "3%",
    "Hispanic": "4%"
  },
  "53033032316": {
    "key": 53033032316,
    "Population": 5654,
    "White": "70%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "24%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "2%"
  },
  "53033032317": {
    "key": 53033032317,
    "Population": 6402,
    "White": "71%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "14%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "8%",
    "Hispanic": "6%"
  },
  "53033032318": {
    "key": 53033032318,
    "Population": 6712,
    "White": "53%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "35%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "6%"
  },
  "53033032319": {
    "key": 53033032319,
    "Population": 5941,
    "White": "80%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "6%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "5%",
    "Hispanic": "7%"
  },
  "53033032320": {
    "key": 53033032320,
    "Population": 4535,
    "White": "85%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "7%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "4%"
  },
  "53033032321": {
    "key": 53033032321,
    "Population": 6365,
    "White": "55%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "34%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "3%"
  },
  "53033032322": {
    "key": 53033032322,
    "Population": 3560,
    "White": "75%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "17%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "2%"
  },
  "53033032323": {
    "key": 53033032323,
    "Population": 5888,
    "White": "67%",
    "Black": "1%",
    "Native Am.": "1%",
    "Asian": "19%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "4%",
    "Hispanic": "8%"
  },
  "53033032324": {
    "key": 53033032324,
    "Population": 5292,
    "White": "57%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "33%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "8%"
  },
  "53033032325": {
    "key": 53033032325,
    "Population": 5805,
    "White": "48%",
    "Black": "6%",
    "Native Am.": "1%",
    "Asian": "29%",
    "Pacific Isl.": "0%",
    "Other": "1%",
    "Multiracial": "8%",
    "Hispanic": "8%"
  },
  "53033032326": {
    "key": 53033032326,
    "Population": 3960,
    "White": "74%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "12%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "11%"
  },
  "53033032327": {
    "key": 53033032327,
    "Population": 4201,
    "White": "85%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "9%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "1%",
    "Hispanic": "4%"
  },
  "53033032328": {
    "key": 53033032328,
    "Population": 3490,
    "White": "76%",
    "Black": "2%",
    "Native Am.": "1%",
    "Asian": "9%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "8%"
  },
  "53033032329": {
    "key": 53033032329,
    "Population": 9101,
    "White": "50%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "44%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "3%"
  },
  "53033032401": {
    "key": 53033032401,
    "Population": 6132,
    "White": "93%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "3%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "1%"
  },
  "53033032402": {
    "key": 53033032402,
    "Population": 6847,
    "White": "86%",
    "Black": "1%",
    "Native Am.": "1%",
    "Asian": "1%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "9%"
  },
  "53033032500": {
    "key": 53033032500,
    "Population": 5381,
    "White": "87%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "2%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "7%"
  },
  "53033032601": {
    "key": 53033032601,
    "Population": 3219,
    "White": "78%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "4%",
    "Pacific Isl.": "1%",
    "Other": "0%",
    "Multiracial": "7%",
    "Hispanic": "9%"
  },
  "53033032602": {
    "key": 53033032602,
    "Population": 14018,
    "White": "78%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "11%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "5%",
    "Hispanic": "4%"
  },
  "53033032702": {
    "key": 53033032702,
    "Population": 6720,
    "White": "91%",
    "Black": "2%",
    "Native Am.": "0%",
    "Asian": "1%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "3%"
  },
  "53033032703": {
    "key": 53033032703,
    "Population": 2285,
    "White": "84%",
    "Black": "0%",
    "Native Am.": "0%",
    "Asian": "5%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "9%"
  },
  "53033032704": {
    "key": 53033032704,
    "Population": 7051,
    "White": "82%",
    "Black": "1%",
    "Native Am.": "0%",
    "Asian": "2%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "3%",
    "Hispanic": "12%"
  },
  "53033032800": {
    "key": 53033032800,
    "Population": 2347,
    "White": "92%",
    "Black": "0%",
    "Native Am.": "1%",
    "Asian": "1%",
    "Pacific Isl.": "0%",
    "Other": "0%",
    "Multiracial": "2%",
    "Hispanic": "5%"
  }
}